import PropTypes from "prop-types";
import React, { useState } from "react";
import {
  FaInstagram,
  FaXTwitter,
  FaYoutube,
  FaDiscord,
  FaLinkedin,
  FaTiktok,
  FaTwitch,
  FaTelegram,
  FaMedium,
} from "react-icons/fa6";
import { SiOpensea } from "react-icons/si";
import ReactPlayer from "react-player";

import {
  Button,
  Carousel,
  CarouselControl,
  CarouselIndicators,
  CarouselItem,
  Col,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";

const ArtistModal = (
  {
    subHeader,
    headline,
    text,
    items,
    insta,
    twitter,
    youtube,
    discord,
    linkedin,
    tiktok,
    twitch,
    telegram,
    medium,
    opensea,
    link,
  },
  context
) => {
  const [showModal, setShowModal] = useState(false);

  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items?.map((item) => (
    <CarouselItem
      onExiting={() => setAnimating(true)}
      onExited={() => setAnimating(false)}
      key={item.key}
    >
      {item?.type == "video" ? (
        <ReactPlayer
          url={item.src}
          controls={false}
          playing={true}
          playsinline
          muted={true}
          loop={true}
          width="100%"
          height="auto"
        />
      ) : (
        <img src={item?.src} width="100%" height="auto" alt={item.altText} />
      )}
    </CarouselItem>
  ));

  return (
    <>
      <div className="d-grid gap-2 col-md-5 col-12 pt-md-3 px-2">
        <Button
          className="w-100 rounded-pill py-2"
          color="primary"
          outline
          onClick={() => setShowModal(true)}
        >
          {context.t("Learn more")}
        </Button>
      </div>
      <Modal
        isOpen={showModal}
        size="xl"
        toggle={() => setShowModal(!showModal)}
        fullscreen={true}
      >
        <ModalBody className="p-4 connect-modal-body">
          <button
            className="btn-close-white btn-close position-absolute top-0 end-0 p-4"
            onClick={() => setShowModal(false)}
            aria-label={context.t("close")}
          ></button>
          <Row className="justify-content-center p-4">
            <Col
              xs={12}
              lg={5}
              className="d-flex flex-column justify-content-center"
            >
              <p className="text-uppercase h6 pb-3 text-left">{subHeader}</p>
              <h1 className="display-4">{headline}</h1>
              <p>{text}</p>
              {link && (
                <div className="mb-3">
                  <a
                    target="_blank"
                    href={link}
                    rel="noreferrer"
                    className={`btn btn-outline-primary rounded-pill py-2 px-5`}
                  >
                    {context.t("Visit")}
                  </a>
                </div>
              )}
              <div className="d-flex flex-wrap">
                {twitter && (
                  <a
                    target="_blank"
                    href={twitter}
                    rel="noreferrer"
                    className="me-3"
                  >
                    <FaXTwitter size="20px" />
                  </a>
                )}
                {insta && (
                  <a
                    target="_blank"
                    href={insta}
                    rel="noreferrer"
                    className="me-3"
                  >
                    <FaInstagram size="20px" />
                  </a>
                )}
                {youtube && (
                  <a
                    target="_blank"
                    href={youtube}
                    rel="noreferrer"
                    className="me-3"
                  >
                    <FaYoutube size="20px" />
                  </a>
                )}
                {discord && (
                  <a
                    target="_blank"
                    href={discord}
                    rel="noreferrer"
                    className="me-3"
                  >
                    <FaDiscord size="20px" />
                  </a>
                )}
                {linkedin && (
                  <a
                    target="_blank"
                    href={linkedin}
                    rel="noreferrer"
                    className="me-3"
                  >
                    <FaLinkedin size="20px" />
                  </a>
                )}
                {tiktok && (
                  <a
                    target="_blank"
                    href={tiktok}
                    rel="noreferrer"
                    className="me-3"
                  >
                    <FaTiktok size="20px" />
                  </a>
                )}
                {twitch && (
                  <a
                    target="_blank"
                    href={twitch}
                    rel="noreferrer"
                    className="me-3"
                  >
                    <FaTwitch size="20px" />
                  </a>
                )}
                {telegram && (
                  <a
                    target="_blank"
                    href={telegram}
                    rel="noreferrer"
                    className="me-3"
                  >
                    <FaTelegram size="20px" />
                  </a>
                )}
                {medium && (
                  <a
                    target="_blank"
                    href={medium}
                    rel="noreferrer"
                    className="me-3"
                  >
                    <FaMedium size="20px" />
                  </a>
                )}
                {opensea && (
                  <a
                    target="_blank"
                    href={opensea}
                    rel="noreferrer"
                    className="me-3"
                  >
                    <SiOpensea size="20px" />
                  </a>
                )}
              </div>
            </Col>
            <Col xs={12} lg={6} className="align-items-center text-center">
              {items && (
                <>
                  {items?.length > 1 ? (
                    <Carousel
                      activeIndex={activeIndex}
                      next={next}
                      previous={previous}
                    >
                      <CarouselIndicators
                        items={items}
                        activeIndex={activeIndex}
                        onClickHandler={goToIndex}
                      />
                      {slides}
                      <CarouselControl
                        direction="prev"
                        directionText="Previous"
                        onClickHandler={previous}
                      />
                      <CarouselControl
                        direction="next"
                        directionText="Next"
                        onClickHandler={next}
                      />
                    </Carousel>
                  ) : (
                    <img
                      src={items[0]?.src}
                      width="100%"
                      height="auto"
                      alt="artist-image-popover"
                    />
                  )}
                </>
              )}
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

/**  define proptype for the 'translation' function  */
ArtistModal.contextTypes = {
  t: PropTypes.func,
};

ArtistModal.propTypes = {
  subHeader: PropTypes.string,
  headline: PropTypes.string,
  text: PropTypes.string,
  items: PropTypes.array,
  insta: PropTypes.string,
  twitter: PropTypes.string,
  youtube: PropTypes.string,
  discord: PropTypes.string,
  linkedin: PropTypes.string,
  tiktok: PropTypes.string,
  twitch: PropTypes.string,
  telegram: PropTypes.string,
  medium: PropTypes.string,
  opensea: PropTypes.string,
  link: PropTypes.string,
};

ArtistModal.defaultProps = {};

export default ArtistModal;
